export const ANNUAL_RATE_15 = 0.0221;
export const ANNUAL_RATE_35 = 0.0257;
export const INVESTMENT_RATE_MONTHLY = 0.06 / 12;

export const getAnnualRateForPlan = (planYears) =>
  Number(planYears) === 15 ? ANNUAL_RATE_15 : ANNUAL_RATE_35;
